
















import { Component, Vue } from 'vue-property-decorator';
import Settings from '@/components/Settings.vue';
import Footer from '@/components/Footer.vue';
import { namespace } from 'vuex-class';
import Home from '@/views/Home.vue';
import Skills from '@/views/Skills.vue';
import Experience from '@/views/Experience.vue';

const settings = namespace('Settings');

@Component({
  components: {
    Settings,
    Home,
    Skills,
    Experience,
    Footer,
  },
})
export default class App extends Vue {
  @settings.State public colorMode!: 'light' | 'dark';
  @settings.Mutation public setColorMode!: (mode: 'light' | 'dark') => void;
}
